import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const godaddy = defineConnector({
  identifier: "godaddy",
  name: "GoDaddy",
  tagLine: "Domain registration and hosting",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: () => "https://api\\.godaddy\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: `${app.config.apiKey}:${app.secret.apiSecret}`,
        scheme: "sso-key",
      },
    ]),
  steps: [
    {
      title: "Get API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Visit the [GoDaddy Developer Portal](https://developer.godaddy.com/keys) and create a new API key and secret.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "configuration", field: "apiKey" },
        },
        {
          kind: "input",
          label: "API secret",
          required: true,
          target: { kind: "secrets", field: "apiSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.godaddy.com/v1/domains",
  },
});
